import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function CallForSponsorship() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sponsorshipTiers = [
    { tier: 'Bronze', amount: '< 50,000', delegates: '-', website: '✓', booth: 'On availability', talk: '-' },
    { tier: 'Silver', amount: '50,000 - 75,000', delegates: '1', website: '✓', booth: '✓', talk: '10 min' },
    { tier: 'Gold', amount: '75,000 - 1,00,000', delegates: '2', website: '✓', booth: '✓', talk: '15 min' },
    { tier: 'Diamond', amount: '1,00,000 - 1,50,000', delegates: '3', website: '✓', booth: '✓', talk: '20 min' },
    { tier: 'Platinum', amount: '1,50,000 - 2,00,000', delegates: '4', website: '✓', booth: '✓', talk: '25 min' },
    { tier: 'Premier', amount: '> 2,00,000', delegates: '5', website: '✓', booth: 'Preferred Location', talk: '35 min' }
  ];

  return (
    <div className="page-container">
      <PageCarousel />
      
      <section className="section-padding bg-white">
        <div className="container">
          
          {/* 1. Header Section */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="section-title" style={{ fontWeight: 700, color: '#111' }}>Call for Sponsorship</h1>
              <div style={{ width: '80px', height: '4px', background: '#70b60a', margin: '15px auto' }}></div>
              <p className="col-lg-12 mx-auto mt-4 text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                NCVPRIPG 2026 is India's premier national conference focused on Computer Vision, Pattern Recognition, Image Processing, and Graphics. 
                Hosted at <strong>LNMIIT Jaipur</strong> in collaboration with <strong>IUPRAI</strong>, this event connects academic researchers, students, and industry experts.
              </p>
            </div>
          </div>

          {/* 2. Intro Info Cards */}
          <div className="row mb-5">
             <div className="col-lg-6 mb-4">
                <div className="p-4 h-100 rounded shadow-sm border-left-green" style={{ background: '#f9fff0', borderLeft: '5px solid #70b60a' }}>
                   <h5 className="font-weight-bold">Why Sponsor Us?</h5>
                   <p className="small text-muted mb-0">
                      With 250-300+ expected participants, sponsoring NCVPRIPG gives you a unique platform to showcase products, 
                      recruit top talent, and forge industry-academia collaborations. You'll engage with experts through Plenary Talks, 
                      Industry sessions, and Workshops.
                   </p>
                </div>
             </div>
             <div className="col-lg-6 mb-4">
                <div className="p-4 h-100 rounded shadow-sm border-left-green" style={{ background: '#f9fff0', borderLeft: '5px solid #70b60a' }}>
                   <h5 className="font-weight-bold">Networking Opportunities</h5>
                   <p className="small text-muted mb-0">
                      Reserve demo tables, sponsor specific sessions, or deliver a talk. Sponsorship tiers are designed to provide maximum visibility through 
                      our website, onsite booths, and direct interaction with the research community.
                   </p>
                </div>
             </div>
          </div>

          {/* 3. Sponsorship Matrix Table */}
          <div className="row mb-5">
            <div className="col-12">
              <h3 className="mb-4" style={{ borderLeft: '5px solid #70b60a', paddingLeft: '15px', fontWeight: 600 }}>Sponsorship Tiers & Benefits</h3>
              <div className="table-responsive shadow-lg rounded" style={{ overflow: 'hidden' }}>
                <table className="table table-hover mb-0 text-center">
                  <thead style={{ background: '#2c3e50', color: '#fff' }}>
                    <tr>
                      <th style={{ padding: '20px', textAlign: 'left', minWidth: '250px' }}>Offerings / Acknowledgements</th>
                      {sponsorshipTiers.map((s, i) => (
                        <th key={i} style={{ padding: '20px', background: s.tier === 'Premier' ? '#70b60a' : '' }}>{s.tier}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: '15px' }}>
                    <tr className="bg-light">
                      <td className="text-left font-weight-bold">INR (excluding GST)</td>
                      {sponsorshipTiers.map((s, i) => (
                        <td key={i} className="font-weight-bold text-success">{s.amount}</td>
                      ))}
                    </tr>
                    <tr>
                      <td className="text-left">Free Registrations (Delegates)</td>
                      {sponsorshipTiers.map((s, i) => <td key={i}>{s.delegates}</td>)}
                    </tr>
                    <tr>
                      <td className="text-left">NCVPRIPG Website Visibility</td>
                      {sponsorshipTiers.map((s, i) => <td key={i}>{s.website}</td>)}
                    </tr>
                    <tr>
                      <td className="text-left">Exhibit Booth</td>
                      {sponsorshipTiers.map((s, i) => <td key={i}>{s.booth}</td>)}
                    </tr>
                    <tr>
                      <td className="text-left">Sponsored Session Talk</td>
                      {sponsorshipTiers.map((s, i) => <td key={i}>{s.talk}</td>)}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* 4. Contact & Action Section */}
          <div className="row mt-5">
            <div className="col-lg-10 mx-auto">
              <div className="p-5 text-center rounded shadow-sm border" style={{ background: '#fff' }}>
                <h4 className="font-weight-bold mb-3">Interested in Sponsoring?</h4>
                <p className="text-muted">
                  Please send us an email with your organization's contact information. 
                  Our committee will review your proposal and get back to you within <strong>five working days</strong>.
                </p>
                <div className="mt-4">
                   <a href="mailto:ncvpripg2026@lnmiit.ac.in" className="btn btn-success btn-lg px-5" style={{ background: '#70b60a', border: 'none', borderRadius: '30px' }}>
                      <i className="lni-envelope mr-2"></i>&nbsp; ncvpripg2026@lnmiit.ac.in
                   </a>
                </div>
              </div>
              <p className="text-center mt-4 small text-muted italic">
                * Note: Free registration includes access to all conference sessions, keynote talks, and networking events.
              </p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default CallForSponsorship;